export class GoogleRegistrationResponseDto {
  email: string = '';
  givenName?: string;
  familyName?: string;
  fullName?: string;
  googleId: string = '';
}
